import React from 'react';
import { appColors, config, imageURLs, PY_TEXTS, pageURL_PY } from '../constants';
import { configHN } from './UIConfig_HN';

const newValues = {
  ClientInformation: {
    title: 'Ingresá los datos del CLIENTE',
    formFields: [
      {
        type: 'formRow',
        components: [
          {
            flexSpan: 0.75,
            marginRight: '15px',
            component: [
              {
                name: 'documentType',
                label: 'Tipo',
                id: 'documentType',
                type: 'collapsibleList',
                variant: 'outlined',
                flexSpan: 2,
                options: [
                  { value: 'CI', label: 'CI' },
                  { value: 'DE', label: 'DE' },
                  { value: 'RUC', label: 'RUC' },
                ],
              },
            ],
          },
          {
            flexSpan: 2,
            component: [
              {
                name: 'documentNumber',
                label: 'Nro. documento',
                id: 'documentNumber',
                type: 'tel',
                variant: 'outlined',
                inputProps: { mask: config.mask['HN'].documentNumber, maxLength: 20 },
                validations: {
                  maxLength: 30,
                },
                mask: (value) => value.documentType === 'CC',
              },
            ],
          },
        ],
      },
      {
        name: 'cliNationality',
        label: 'Nacionalidad',
        id: 'cliNationality',
        type: 'collapsibleList',
        variant: 'outlined',
        conditionalDisplay: true,
        options: [
          { value: 'AR', label: 'ARGENTINA' },
          { value: 'BR', label: 'BOLIVIA' },
          { value: 'BO', label: 'BRASIL' },
          { value: 'CL', label: 'CHILE' },
          { value: 'CO', label: 'COLOMBIA' },
          { value: 'UY', label: 'URUGUAY' },
          { value: 'VE', label: 'VENEZUELA' },
          { value: 'US', label: 'ESTADOS UNIDOS' },
          { value: 'MX', label: 'MEXICO' },
          { value: 'DE', label: 'ALEMANIA' },
          { value: 'CA', label: 'CANADA' },
          { value: 'ES', label: 'ESPAÑA' },
          { value: 'FR', label: 'FRANCIA' },
          { value: 'LB', label: 'LIBANO' },
          { value: 'GB', label: 'REINO UNIDO' },
        ],
      },
      {
        name: 'cliFirstName',
        label: 'Nombre o Razón Social',
        id: 'cliFirstName',
        type: 'text',
        variant: 'outlined',
        uppercase: true,
      },
      {
        name: 'cliLastName',
        label: 'Apellidos',
        id: 'cliLastName',
        type: 'text',
        variant: 'outlined',
        uppercase: true,
      },
      {
        name: 'dateOfBirth',
        id: 'dateOfBirth',
        type: 'date',
        variant: 'outlined',
        placeholder: 'DD/MM/YYYY',
        disablePast: false,
        label: 'Fecha de nacimiento',
        calendarProps: {
          selectFromAvailable: false,
          disableFuture: true,
          helperText: '',
        },
      },
      {
        name: 'cliTelephone',
        label: 'Número celular',
        id: 'cliTelephone',
        type: 'tel',
        variant: 'outlined',
        inputProps: { maxLength: 8 },
        placeholder: '00000000',
        InputProps: {
          startAdornment: <span style={{ color: '#555555' }}>5959</span>,
        },
      },
      {
        name: 'cliAlternateTelephone',
        label: 'Número contacto adicional o encargado',
        id: 'cliAlternateTelephone',
        type: 'tel',
        variant: 'outlined',
        inputProps: { maxLength: 8 },
        placeholder: '00000000',
        InputProps: {
          startAdornment: <span style={{ color: '#555555' }}>5959</span>,
        },
      },
      {
        name: 'cliEmail',
        label: 'Correo electrónico',
        id: 'cliEmail',
        type: 'text',
        variant: 'outlined',
      },
      {
        type: 'button',
        text: 'confirmar',
        name: 'submit',
        alignSelf: 'center',
        disabled: false,
      },
      {
        type: 'button-group',
        buttons: [
          {
            text: 'cancelar',
            name: 'cancel',
            alignSelf: 'center',
            variant: 'rounded',
            disabled: false,
            type: 'cancel',
            style: {
              background: 'transparent',
              color: appColors.secondaryCyan,
            },
          },
        ],
      },
    ],
    redirectURLs: {
      redirectURL: pageURL_PY.error,
      nextURL: pageURL_PY.inputAddress,
      serviceSelection: pageURL_PY.seleccionDeServicios,
    },
  },
  ClientInformationCrosselling: {
    title: 'Ingresá el número de documento del cliente',
    formFields: [
      {
        type: 'formRow',
        components: [
          {
            flexSpan: 0.75,
            marginRight: '15px',
            component: [
              {
                name: 'documentType',
                label: 'Tipo',
                id: 'documentType',
                type: 'collapsibleList',
                variant: 'outlined',
                flexSpan: 2,
                options: [
                  { value: 'CI', label: 'CI' },
                  // { value: 'DE', label: 'DE' }
                ],
              },
            ],
          },
          {
            flexSpan: 2,
            component: [
              {
                name: 'documentNumber',
                label: 'Nro. documento',
                id: 'documentNumber',
                type: 'tel',
                variant: 'outlined',
                inputProps: { mask: config.mask['HN'].documentNumber, maxLength: 20 },
                validations: {
                  maxLength: 30,
                },
                mask: (value) => value.documentType === 'CC',
              },
            ],
          },
        ],
      },
      {
        name: 'cliFullName',
        label: 'Nombre o Razón Social',
        id: 'cliFullName',
        type: 'text',
        variant: 'outlined',
        uppercase: true,
        disabled: true,
      },
      {
        name: 'cliNationality',
        label: 'Nacionalidad',
        id: 'cliNationality',
        type: 'collapsibleList',
        variant: 'outlined',
        conditionalDisplay: true,
        options: [
          { value: 'AR', label: 'ARGENTINA' },
          { value: 'BR', label: 'BOLIVIA' },
          { value: 'BO', label: 'BRASIL' },
          { value: 'CL', label: 'CHILE' },
          { value: 'CO', label: 'COLOMBIA' },
          { value: 'UY', label: 'URUGUAY' },
          { value: 'VE', label: 'VENEZUELA' },
          { value: 'US', label: 'ESTADOS UNIDOS' },
          { value: 'MX', label: 'MEXICO' },
          { value: 'DE', label: 'ALEMANIA' },
          { value: 'CA', label: 'CANADA' },
          { value: 'ES', label: 'ESPAÑA' },
          { value: 'FR', label: 'FRANCIA' },
          { value: 'LB', label: 'LIBANO' },
          { value: 'GB', label: 'REINO UNIDO' },
        ],
      },
      {
        name: 'dateOfBirth',
        id: 'dateOfBirth',
        type: 'date',
        variant: 'outlined',
        placeholder: 'DD/MM/YYYY',
        disablePast: false,
        label: 'Fecha de nacimiento',
        calendarProps: {
          selectFromAvailable: false,
          disableFuture: true,
          helperText: '',
        },
      },
      {
        name: 'cliTelephone',
        label: 'Número celular',
        id: 'cliTelephone',
        type: 'tel',
        variant: 'outlined',
        inputProps: { maxLength: 12 },
        placeholder: '00000000',
        disabled: true,
      },
    ],
    redirectURLs: {
      redirectURL: pageURL_PY.error,
      nextURL: pageURL_PY.inputAddress,
      serviceSelection: pageURL_PY.seleccionDeServicios,
      home: pageURL_PY.home,
    },
  },
  ProspectInformation: {
    title: 'Ingresá los datos de tu Cliente',
    formFields: [
      {
        type: 'formRow',
        components: [
          {
            flexSpan: 0.75,
            marginRight: '15px',
            component: [
              {
                name: 'documentType',
                label: 'Tipo',
                id: 'documentType',
                type: 'collapsibleList',
                variant: 'outlined',
                flexSpan: 2,
                options: [
                  { value: 'CI', label: 'CI' },
                  { value: 'DE', label: 'DE' },
                  { value: 'RUC', label: 'RUC' },
                ],
              },
            ],
          },
          {
            flexSpan: 2,
            component: [
              {
                name: 'documentNumber',
                label: 'Nro. documento',
                id: 'documentNumber',
                type: 'tel',
                variant: 'outlined',
                inputProps: { mask: config.mask['HN'].documentNumber, maxLength: 20 },
                validations: {
                  maxLength: 30,
                },
                mask: (value) => value.documentType === 'CC',
              },
            ],
          },
        ],
      },
      {
        name: 'cliNationality',
        label: 'Nacionalidad',
        id: 'cliNationality',
        type: 'collapsibleList',
        variant: 'outlined',
        conditionalDisplay: true,
        options: [
          { value: 'AR', label: 'ARGENTINA' },
          { value: 'BR', label: 'BOLIVIA' },
          { value: 'BO', label: 'BRASIL' },
          { value: 'CL', label: 'CHILE' },
          { value: 'CO', label: 'COLOMBIA' },
          { value: 'UY', label: 'URUGUAY' },
          { value: 'VE', label: 'VENEZUELA' },
          { value: 'US', label: 'ESTADOS UNIDOS' },
          { value: 'MX', label: 'MEXICO' },
          { value: 'DE', label: 'ALEMANIA' },
          { value: 'CA', label: 'CANADA' },
          { value: 'ES', label: 'ESPAÑA' },
          { value: 'FR', label: 'FRANCIA' },
          { value: 'LB', label: 'LIBANO' },
          { value: 'GB', label: 'REINO UNIDO' },
        ],
      },
      {
        name: 'cliFirstName',
        label: 'Nombre o Razón Social',
        id: 'cliFirstName',
        type: 'text',
        variant: 'outlined',
        uppercase: true,
      },
      {
        name: 'cliLastName',
        label: 'Apellidos',
        id: 'cliLastName',
        type: 'text',
        variant: 'outlined',
        uppercase: true,
      },
      {
        name: 'dateOfBirth',
        id: 'dateOfBirth',
        type: 'date',
        variant: 'outlined',
        placeholder: 'DD/MM/YYYY',
        disablePast: false,
        label: 'Fecha de nacimiento',
        calendarProps: {
          selectFromAvailable: false,
          disableFuture: true,
          helperText: '',
        },
      },
      {
        name: 'cliTelephone',
        label: 'Número celular',
        id: 'cliTelephone',
        type: 'tel',
        variant: 'outlined',
        inputProps: { maxLength: 8 },
        placeholder: '00000000',
        InputProps: {
          startAdornment: <span style={{ color: '#555555' }}>5959</span>,
        },
      },
      {
        name: 'cliEmail',
        label: 'Correo electrónico',
        id: 'cliEmail',
        type: 'text',
        variant: 'outlined',
      },
      {
        name: 'reminderDate',
        id: 'reminderDate',
        type: 'date',
        variant: 'outlined',
        placeholder: 'DD/MM/YYYY',
        disablePast: true,
        label: 'Fecha de recordatorio',
        calendarProps: {
          selectFromAvailable: false,
          disableFuture: false,
          helperText: '',
        },
      },
      {
        name: 'location',
        label: 'Ubicación',
        id: 'location',
        type: 'text',
        variant: 'outlined',
        disabled: true,
      },
      {
        name: 'addressType',
        label: 'Tipo de dirección',
        id: 'addressType',
        type: 'collapsibleList',
        variant: 'outlined',
        flexSpan: 2,
        options: [
          { value: 'HOGAR', label: 'HOGAR' },
          { value: 'EDIFICIO', label: 'EDIFICIO' },
          { value: 'CONDOMINIO', label: 'CONDOMINIO' },
        ],
      },
      {
        name: 'salesType',
        label: 'Tipo de venta',
        id: 'salesType',
        type: 'collapsibleList',
        variant: 'outlined',
        flexSpan: 2,
        options: [
          { value: 'HOGAR', label: 'HOGAR' },
          { value: 'MOBILE', label: 'MOBILE' },
          { value: 'HOGAR + MOBILE', label: 'HOGAR + MOBILE' },
        ],
      },
      {
        name: 'interestedIn',
        label: 'Interesado/a',
        id: 'interestedIn',
        type: 'collapsibleList',
        variant: 'outlined',
        flexSpan: 2,
        options: [
          { value: 'SI', label: 'SI' },
          { value: 'NO', label: 'NO' },
          { value: 'MAS ADELANTE', label: 'MAS ADELANTE' },
        ],
      },
      {
        name: 'addressRef',
        label: 'Observaciones',
        id: 'addressRef',
        type: 'textarea',
        variant: 'outlined',
        rows: 5,
        multiline: true,
        optional: true,
        helperText: (value) => `${value.length} / 255`,
        inputProps: {
          maxLength: 255,
        },
      },
      {
        type: 'button',
        text: 'confirmar',
        name: 'submit',
        alignSelf: 'center',
        disabled: false,
      },
      {
        type: 'button-group',
        buttons: [
          {
            text: 'cancelar',
            name: 'cancel',
            alignSelf: 'center',
            variant: 'rounded',
            disabled: false,
            type: 'cancel',
            style: {
              background: 'transparent',
              color: appColors.secondaryCyan,
            },
          },
        ],
      },
    ],
    redirectURLs: {
      redirectURL: pageURL_PY.error,
      nextURL: pageURL_PY.prospects,
    },
  },
};

export const configPY = {
  ...configHN,
  ...newValues,
  HomePage: {
    formFields: [],
    sidebarMenu: [
      {
        title: PY_TEXTS.HOME_NEW_CLIENT,
        url: pageURL_PY.locationServices,
        iconType: '',
      },
      {
        title: PY_TEXTS.HOME_SALES_REPORT,
        url: pageURL_PY.salesReport,
        iconType: '',
      },
      {
        title: PY_TEXTS.PROSPECTS,
        url: pageURL_PY.prospects,
        iconType: '',
      },
      {
        title: PY_TEXTS.HOME_LOGOUT,
        url: '',
        iconType: '',
      },
    ],
  },
  ValidationError: {
    icon: imageURLs.failed,
    redirectURLs: {
      prevURL: pageURL_PY.clientInformation,
    },
  },
  ConfirmOrder: {
    title: 'Confirmá tu orden',
    redirectURLs: {
      progress: pageURL_PY.transactionInProgress,
      success: pageURL_PY.orderSuccess,
      fail: pageURL_PY.orderFail,
      product: pageURL_PY.products,
      pre2pos: pageURL_PY.pre2pos,
    },
  },
};
